<script>
import axios from 'axios';

export default {
  name: 'TomWidget',
  data() {
    return {
      toms: [],
      pchartColors: ['#CFD8DC', '#C8E6C9', '#81C784', '#26a73a', '#EF5350', '#D32F2F'],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      axios.get('/tom')
        .then((response) => {
          const tempToms = response.data;
          let openCount = 0;
          let inProgressCount = 0;
          let sendCount = 0;
          let approvedCount = 0;
          let approvedWithFlawCount = 0;
          let unapprovedFlawCount = 0;
          let inApprovalCount = 0;

          tempToms.forEach((it) => {
            const examState = it.examState ? it.examState.name.toLowerCase() : null;

            switch (examState) {
              case null:
              case 'offen': openCount += 1; break;
              case 'in bearbeitung': inProgressCount += 1; break;
              case 'versendet': sendCount += 1; break;
              case 'genehmigt': approvedCount += 1; break;
              case 'genehmigt mit mangel': approvedWithFlawCount += 1; break;
              case 'nicht genehmigt': unapprovedFlawCount += 1; break;
              case 'zur prüfung': inApprovalCount += 1; break;
              default: break;
            }
          });

          if (!(openCount || inProgressCount || approvedCount || sendCount
              || approvedWithFlawCount || unapprovedFlawCount || inApprovalCount)) {
            this.toms = [];
          } else {
            this.toms = [
              ['offen', openCount], ['in Bearbeitung', inProgressCount], ['versendet', sendCount], ['genehmigt', approvedCount],
              ['genehmigt mit Mangel', approvedWithFlawCount], ['nicht genehmigt', unapprovedFlawCount], ['zur Prüfung', inApprovalCount],
            ];
          }
        });
    },
    openToms() {
      this.$router.push('/toms');
    },
  },
};
</script>

<template>
  <div>
    <v-card>
      <v-card-title class="cursor-pointer" @click="openToms">
        <v-icon large left>
          assignment_late
        </v-icon>
        <span class="title">TOMs</span>
      </v-card-title>
      <pie-chart :data="toms" :colors="pchartColors" />
    </v-card>
  </div>
</template>
